import { PageConstant } from '../../constants';
import { COMPARE_STATUS, IS_VETTING_USEABLE, STATUS, STATUS_RANK } from '../../legacy_components/constants/status';

export function calculateWidths(progressBarData) {
  const barWidths = [];
  let activeTitleSet = false;
  const { stages: tasksList } = computeCompletedStatus(progressBarData);
  tasksList.forEach((stage, index) => {
    if (stage.progress < 100) {
      if (!activeTitleSet) {
        barWidths.push({
          width: stage.progress,
          active: true,
          titleActive: true,
          title: stage.title,
          shortTitle: stage.shortTitle,
          tasks: stage.tasks
        });
        activeTitleSet = true;
      } else {
        barWidths.push({
          width: 0,
          active: false,
          titleActive: false,
          title: stage.title,
          shortTitle: stage.shortTitle,
          tasks: stage.tasks
        });
      }
    } else {
      barWidths.push({
        width: stage.progress,
        active: false,
        titleActive: true,
        title: stage.title,
        shortTitle: stage.shortTitle,
        progressComplete: index === tasksList.length - 1 && stage.progress === 100,
        tasks: stage.tasks
      });
    }
  });
  return barWidths;
}

export const titles = [
  'Basic Information',
  'Turing Assessment',
  'Profile Completion',
  'Get Hired'
];

export const STEPS = {
  COMPLETE_ASA: {
    text: 'Complete the Work Experience Survey',
    route: PageConstant.MCQ_LIST,
    time: '15 min',
    buttonText: 'Go to Quizzes'
  },
  ATTEMPT_CORE_SKILLS: {
    text: 'Take one of the core quizzes for your role',
    route: PageConstant.MCQ_LIST,
    time: "45 min",
    buttonText: 'Go to Quizzes'
  },
  UPDATE_AVAILABILITY: {
    text: 'Update your Work Availability',
    action: "availabilitymodal",
    time: '1 min',
    buttonText: 'Update'
  },
  ATTEMPT_PRACTICE_ACC: {
    text: 'Take the Practice Coding Challenge (Optional)',
    route: PageConstant.CODING_CHALLENGE,
    time: '45 min',
    buttonText: 'Go to Challenges'
  },
  COMPLETE_CLOUD_CHALLENGE: {
    text: 'Take the Practical Challenge',
    route: PageConstant.CODING_CHALLENGE,
    time: null,
    buttonText: 'Go to Challenge'
  },
  COMPLETE_ACC: {
    text: 'Take the Coding Challenge',
    route: PageConstant.CODING_CHALLENGE,
    time: '30 min',
    buttonText: 'Go to Challenges'
  },
  COMPLETE_PROFILE: {
    text: 'Complete Profile',
    route: PageConstant.FINALIZE_RESUME,
    time: '1 hour',
    buttonText: 'Go to Profile'
  },
  ADDITIONAL_TESTS: {
    text: 'Take Additional Relevant Quizzes',
    route: PageConstant.MCQ_LIST,
    time: '1.5 hour',
    buttonText: 'Go to Quizzes'
  },
  TAKE_PRACTICE_MCQ: {
    text: 'Take the Practice MCQ Quiz (Optional)',
    route: PageConstant.MCQ_LIST,
    time: '3 min',
    buttonText: 'Go to Quizzes'
  },
  RECORDED_SOFT_SKILLS: {
    text: 'Record Soft Skills Evaluation',
    route: PageConstant.SOFT_SKILLS,
    time: '15 min',
    buttonText: 'Go to Soft Skills'
  },
  ADDITIONAL_QUIZZES: {
    text: 'Take Additional Quizzes',
    route: PageConstant.MCQ_LIST,
    time: '45min',
    buttonText: 'Go to Quizzes'
  },
  RELEVANT_QUIZZES: {
    text: 'Take Relevant Quizzes',
    route: PageConstant.MCQ_LIST,
    time: '45min',
    buttonText: 'Go to Quizzes'
  }
};

const stages = ({ isProgrammerRole = true, showCloudChallenge = false, flags, showCoreQuiz }) => {
  const {
    enableSoftSkills,
    useRoleBasedMcqUiux=false
  } = flags;
  return [
    {
      title: 'Basic Information',
      shortTitle: 'Basic Info',
      tasks: [
        { text: 'Sign up', status: STATUS.SIGN_UP },
        {
          text: 'Basic Info Form', status: STATUS.SIGNUP_COMPLETED,
          steps: useRoleBasedMcqUiux ? (
            showCoreQuiz ? [{
              ...STEPS.ATTEMPT_CORE_SKILLS
            }] : [
              { ...STEPS.RELEVANT_QUIZZES }
            ]
          ) : []
        },
        ...(!useRoleBasedMcqUiux ? [
              {
                text: 'Take Work Experience Survey',
                status: STATUS.COMPLETED_ASA,
                preReq: "workExpCompleted",
                steps: [
                  {
                    priority: true,
                    ...STEPS.COMPLETE_ASA
                  },
                  {
                    ...STEPS.UPDATE_AVAILABILITY
                  },
                  ...(showCoreQuiz ? [
                    {
                      ...STEPS.ATTEMPT_CORE_SKILLS,
                      locked: true,
                    }
                  ] : [
                    { 
                      ...STEPS.RELEVANT_QUIZZES,
                      locked: true,
                     }
                  ])
                ],
              }
        ] : [])

      ]
    },
    {
      title: 'Turing Assessment',
      shortTitle: 'Assessment',
      tasks: [
        {
          text: showCoreQuiz ? 'Complete one Core Quiz' : 'Take Relevant Quizzes',
          status: STATUS.SCHEDULING_TECH_INTERVIEW, 
          preReq: "completedCoreMCQ",
          steps: [
            ...(showCoreQuiz ? [
              {
                priority: true,
                ...STEPS.ATTEMPT_CORE_SKILLS
              },
            ] : [
              {
                priority: true,
                ...STEPS.RELEVANT_QUIZZES
              },
            ]),
            {
              ...STEPS.TAKE_PRACTICE_MCQ,
              optional: true,
            },
            {
              ...STEPS.UPDATE_AVAILABILITY
            },
            ...(isProgrammerRole ? [
              {
                ...STEPS.COMPLETE_ACC,
                locked: true,
              }] : []
            )
          ]
        },
        {
          text: 'Pass Coding Challenge',
          status: STATUS.PASSED_CODING_CHALLENGE,
          programmerPreReq: "passedAcc",
          steps: [
            ...(showCloudChallenge ? [
              {
                priority: true,
                ...STEPS.COMPLETE_CLOUD_CHALLENGE,
              }] : isProgrammerRole ? [
                {
                  priority: true,
                  ...STEPS.COMPLETE_ACC,
                },
                {
                  ...STEPS.ATTEMPT_PRACTICE_ACC,
                  optional: true,
                },
                ...(enableSoftSkills ? [
                  {
                    priority: true,
                    locked: true,
                    ...STEPS.RECORDED_SOFT_SKILLS
                  }
                ] : [])] : []
            ),
            {
              ...STEPS.UPDATE_AVAILABILITY
            },
            {
              ...STEPS.COMPLETE_PROFILE,
              locked: true,
            }
          ]
        }
      ]
    },
    {
      title: 'Profile Completion',
      shortTitle: 'Profile',
      tasks: enableSoftSkills ? [
        {
          text: 'Record Soft Skills Evaluation',
          status: STATUS.PASSED_TI,
          checkSoftSkills: true,
          steps: [
            {
              priority: true,
              ...STEPS.RECORDED_SOFT_SKILLS
            },
            ...(useRoleBasedMcqUiux ? [
              {
                locked: true,
                ...STEPS.COMPLETE_PROFILE
              }
            ] : []),
            {
              locked: useRoleBasedMcqUiux ? true : false,
              ...STEPS.ADDITIONAL_QUIZZES
            }
          ]
        },
        {
          text: 'Complete your Profile',
          status: STATUS.COMPLETED_PROFILE,
          preReq: "turingProfileCompleted",
          steps: [
            {
              priority: true,
              ...STEPS.COMPLETE_PROFILE
            },
            {
              ...STEPS.UPDATE_AVAILABILITY
            },
            {
              ...STEPS.ADDITIONAL_TESTS
            }
          ]
        },
      ] : [{
        text: 'Complete your Profile',
        status: STATUS.COMPLETED_PROFILE,
        preReq: "turingProfileCompleted",
        steps: [
          {
            priority: true,
            ...STEPS.COMPLETE_PROFILE
          },
          {
            ...STEPS.UPDATE_AVAILABILITY
          },
          {
            ...STEPS.ADDITIONAL_TESTS
          }
        ]
      },
      ]
    },
    {
      title: 'Get Hired',
      shortTitle: 'Get Hired',
      tasks: [
        {
          text: 'Get Shortlisted for a Job',
          status: STATUS.AVAILABLE_SUPPLY,
          checkUserJobs: true,
        },
        {
          text: 'Stay tuned for a match',
          status: STATUS.AVAILABLE_SUPPLY,
          checkUserJobsInReview: true
        },
        {
          text: 'Get Hired',
          status: STATUS.IN_TRIAL
        }
      ]
    }
  ];
}

export const getDefaultStatus = (a, b) => {
  if (IS_VETTING_USEABLE(a)) {
    if (a === STATUS.FAILED) {
      return STATUS.PASSED_TECH_STACK;
    }
    return (STATUS_RANK[a] || -1) > (STATUS_RANK[b] || -1) ? a : b;
  }
  return b;
};

export const computeCompletedStatus = (progressBarData) => {
  const {
    currentStatus,
    isProgrammerRole = true,
    showCloudChallenge = false,
    userJobs = [],
    extraPassedInfo = {},
    workExpCompleted,
    turingProfileCompleted,
    takenSoftSkills,
    coreSkillPassed,
    flags,
    showCoreQuiz,
    passedAdditionalMCQ
  } = progressBarData
  const status = getDefaultStatus(currentStatus, STATUS.SIGNUP_COMPLETED);
  let nextTaskSet = false;
  return {
    stages: stages({ isProgrammerRole, showCloudChallenge, flags, showCoreQuiz }).map(stage => {
      const tasks = stage.tasks.filter(task => isProgrammerRole ? true : task.status !== STATUS.PASSED_CODING_CHALLENGE).map((task) => {
        let completed = -1;
        if (task.checkUserJobsInReview && COMPARE_STATUS(status, task.status) >= 0) {
          if(Array.isArray(userJobs)){
            completed = userJobs.filter(job =>
              job.job_status !== '--' &&
              job.job_status !== 'Shortlisted' &&
              job.job_status !== 'Not selected'
            ).length > 0 ? 1 : -1;
          }
        } else if (task.checkUserJobs && COMPARE_STATUS(status, task.status) >= 0) {
          if(Array.isArray(userJobs)){
            completed = userJobs.filter(job => job.job_status !== '--' && job.job_status !== 'Not selected').length > 0 ? 1 : -1;
          }
        } else if (task.extraCompletionCheck) {
          completed = extraPassedInfo[task.extraCompletionCheck] || COMPARE_STATUS(status, task.status);
        } else if (task.programmerPreReq && isProgrammerRole) {
          completed = extraPassedInfo[task.programmerPreReq] ? COMPARE_STATUS(status, task.status) : -1;
        } else if (task.preReq) {
          const passedCore = showCoreQuiz ? coreSkillPassed : passedAdditionalMCQ;
          if (task.preReq === 'workExpCompleted') completed = workExpCompleted ? 1 : -1;
          if (task.preReq === 'turingProfileCompleted') completed = turingProfileCompleted ? 1 : -1;
          if (task.preReq === "completedCoreMCQ") completed = COMPARE_STATUS(status, task.status) >= 0 || passedCore ? 1 : -1;
        } else if (task.checkSoftSkills) {
          completed = takenSoftSkills ? 1 : -1;
        } else {
          completed = COMPARE_STATUS(status, task.status);
        }
        let nextTask = false;
        if (completed < 0 && !nextTaskSet) {
          nextTask = true;
          nextTaskSet = {
            ...task, completed, nextTask
          };
        }
        return {
          ...task,
          completed,
          nextTask
        };
      });
      return {
        ...stage,
        tasks,
        progress: (tasks.reduce(cumulateProgress, 0) / tasks.length) * 100
      };
    }),
    nextTask: nextTaskSet
  };
};

function cumulateProgress(a, b) {
  return b.completed >= 0 ? a + 1 : a;
}
